import { render, staticRenderFns } from "./FormAddSectionMarker.vue?vue&type=template&id=21b385e8&scoped=true"
import script from "./FormAddSectionMarker.vue?vue&type=script&lang=js"
export * from "./FormAddSectionMarker.vue?vue&type=script&lang=js"
import style0 from "./FormAddSectionMarker.vue?vue&type=style&index=0&id=21b385e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b385e8",
  null
  
)

export default component.exports